<template lang="pug">
.form-group
  ed-input-tooltip(v-if="helpBody && focused", :helpHeader="helpHeader", :helpBody="helpBody")
  label.control-label(v-if="fieldLabel") {{fieldLabel}}
    span(v-if="required") &nbsp*
  textarea.form-control(
    :autofocus="autofocus"
    :cols="cols"
    :required="required"
    :value="value"
    v-bind="$props"
    v-focus.lazy="autofocus"
    @focus="focused = true"
    @blur="focused = false"
    @input="$emit('input', $event.target.value)"
  )
</template>

<script>

import EdInputTooltip from '@/core/components/edInputTooltip/index.vue'

export default {
  name: 'ed-textarea',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    fieldLabel: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    value: [String, Number],
    required: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    rows: Number,
    cols: Number,
    helpHeader: String,
    helpBody: String
  },
  directives: {
    focus: {
      inserted: function(el, binding) {
        if (binding.value) el.focus()
        else el.blur()
      },
      componentUpdated: function(el, binding) {
        if (binding.modifiers.lazy) {
          if (Boolean(binding.value) === Boolean(binding.oldValue)) {
            return
          }
        }
        if (binding.value) el.focus()
        else el.blur()
      }
    }
  },
  components: {
    'ed-input-tooltip': EdInputTooltip
  },
  data: function() {
    return {
      focused: false
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

.form-control,
.form-group .form-control {
  @include form-field;
}

.editor.form-group textarea {
  &, &:hover {
    color: $background;
    background: $ink;
  }
}

</style>



// WEBPACK FOOTER //
// index.vue?5d38d4a4